import { FeedItemNotificatonDTO } from '../dtos/FeedItemNotification.dto';
import { FeedItemNotificationModel } from '../models/FeedItemNotification.model';

export class FeedItemNotificationUtils {
  public static mapToViewModel(
    dto: FeedItemNotificatonDTO,
  ): FeedItemNotificationModel {
    return {
      title: dto.title,
      body: dto.body,
      deliveredOn: dto.deliveredOn,
      conversions: dto.conversions,
    };
  }
}
